import { NEUTRAL_10 } from '@/colors/colors';
import React from 'react';

interface InternalChevronProps {
  direction: 'up' | 'left' | 'down' | 'right';
  size?: number;
  color?: string;
}

function getRotateDegree(direction: InternalChevronProps['direction']): number {
  const mapDirectionToDegree: Record<InternalChevronProps['direction'], number> = {
    down: 0,
    left: 90,
    up: 180,
    right: -90,
  };

  return mapDirectionToDegree[direction];
}

function Chevron({ direction, color, size }: InternalChevronProps) {
  const rotateDegree = getRotateDegree(direction);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      style={{
        transform: `rotate(${rotateDegree}deg)`,
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.23177 9.35984C5.58534 8.93556 6.2159 8.87824 6.64018 9.2318L12 13.6983L17.3598 9.2318C17.7841 8.87824 18.4147 8.93556 18.7682 9.35984C19.1218 9.78412 19.0645 10.4147 18.6402 10.7682L12.6402 15.7682C12.2693 16.0773 11.7307 16.0773 11.3598 15.7682L5.35981 10.7682C4.93553 10.4147 4.87821 9.78412 5.23177 9.35984Z"
        fill={color}
      />
    </svg>
  );
}

Chevron.defaultProps = {
  color: NEUTRAL_10,
  size: 24,
};

type ChevronProps = Omit<InternalChevronProps, 'direction'>;

export default {
  Down: ({ color, size }: ChevronProps) => <Chevron direction="down" color={color} size={size} />,
  Left: ({ color, size }: ChevronProps) => <Chevron direction="left" color={color} size={size} />,
  Up: ({ color, size }: ChevronProps) => <Chevron direction="up" color={color} size={size} />,
  Right: ({ color, size }: ChevronProps) => <Chevron direction="right" color={color} size={size} />,
};
